import React from 'react';
import { createRoot } from 'react-dom/client';
import NvChartSettingsForm from './partials/NvChartSettingsForm';
import { initialValues } from "./partials/settings-form/default-values";
import ImportSettingsForm from "./partials/ImportSettingsForm";
import ExportSettingsView from "./partials/ExportSettingsView";

export default function loadCommands(editor, options) {
  const {Commands} = editor;
  const {
    modalTitle,
    componentKey,
    commands,
    formElementID
  } = options;

  const configureCommand = {
    componentKey,
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const {target} = this;

      const componentData = target.get(componentKey) || initialValues;
      let content = `<div id="${formElementID}"></div>`;

      editor.Modal
        .open({title: modalTitle, content})
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));

      const reactRootElement = document.getElementById(formElementID);

      this._reactRoot = createRoot(reactRootElement);
      this._reactRoot.render(<NvChartSettingsForm
        defaultValues={componentData}
        submitHandler={(formValues) => {
          const {editor, target} = this;

          target.addAttributes({'settings': formValues});
          target.set(componentKey, formValues);

          editor.Modal.close();
        }}/>);
    },
    stop() {
      editor.Modal.close();
      if (this._reactRoot) {
        this._reactRoot.unmount();
        this._reactRoot = null;
      }
    }
  };

  const exportCommand = {
    componentKey,
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const {target} = this;

      const componentData = target.get(componentKey) || initialValues;
      const exportJson = JSON.stringify(componentData, null, 2);
      const content = `<div id="${formElementID}" class="nv-chart-settings-form"></div>`;

      editor.Modal
        .open({title: modalTitle, content})
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));

      const reactRootElement = document.getElementById(formElementID);

      const handleDownload = () => {
        const blob = new Blob([exportJson], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'nv-chart-settings.json';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      };

      this._reactRoot = createRoot(reactRootElement);
      this._reactRoot.render(
        <ExportSettingsView json={exportJson} onDownload={handleDownload}/>
      );
    },
    stop() {
      editor.Modal.close();
      if (this._reactRoot) {
        this._reactRoot.unmount();
        this._reactRoot = null;
      }
    }
  };

  const importCommand = {
    componentKey,
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const {target} = this;

      const componentData = { settings: '' };
      const content = `<div id="${formElementID}" class="nv-chart-settings-form import-settings"></div>`;

      editor.Modal
        .open({title: modalTitle, content})
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));

      const reactRootElement = document.getElementById(formElementID);

      this._reactRoot = createRoot(reactRootElement);
      this._reactRoot.render(
        <ImportSettingsForm
          defaultValues={componentData}
          submitHandler={(formValues) => {
            const {editor, target} = this;
            // Yup validation guarantees settings is valid JSON by the time we get here.
            const settings = JSON.parse(formValues.settings);

            target.addAttributes({'settings': settings});
            target.set(componentKey, settings);

            editor.Modal.close();
          }}/>);
    },
    stop() {
      editor.Modal.close();
      if (this._reactRoot) {
        this._reactRoot.unmount();
        this._reactRoot = null;
      }
    }
  };

  Commands.add(commands.configure, configureCommand);
  Commands.add(commands.exportConfig, exportCommand);
  Commands.add(commands.importConfig, importCommand);
}
